<script lang="ts">
  import Toast from './Toast.svelte';
  import { toast } from '$lib/state/toast.svelte';

  function removeToast(id: number) {
    toast.remove(id);
  }
</script>

{#if toast.items.length > 0}
  <div class="fixed top-4 right-4 z-50 space-y-2 max-w-sm">
    {#each toast.items as item (item.id)}
      <div class="pop-in">
        <Toast toast={item} {removeToast} />
      </div>
    {/each}
  </div>
{/if}
